import { render, staticRenderFns } from "./UserStatics.vue?vue&type=template&id=701e13ac&scoped=true"
import script from "./UserStatics.vue?vue&type=script&lang=ts"
export * from "./UserStatics.vue?vue&type=script&lang=ts"
import style0 from "./UserStatics.vue?vue&type=style&index=0&id=701e13ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701e13ac",
  null
  
)

export default component.exports